/**
 * How long a custom sign-in code in `nowadays.users_otp` stays valid. The codes
 * are six digits, so a short life plus one attempt per code keeps guessing out of
 * reach (ENG-726: a verified code links the login to the person who owns the
 * address).
 */
export const CUSTOM_OTP_TTL_MS = 15 * 60 * 1000;

/** How many digits a sign-in code has. */
export const OTP_LENGTH = 6;

/** How long the sign-in form waits before it lets the visitor ask for a new code. */
export const OTP_RESEND_COOLDOWN_SECONDS = 60;

/** How often the resend countdown ticks down by one second. */
export const OTP_RESEND_TICK_MS = 1000;

/** The Route Handler that checks a sign-in code and sets the session cookies. */
export const VERIFY_OTP_PATH = "/api/auth/verify-otp";
